import React from 'react';
import ShieldCrossIcon from '../../library/icons/shield-cross-icon';

const MagicLinkNotActiveComponent = () => {
    return (
        <div className="linkcontent">
            <div className="img">
                <ShieldCrossIcon />
            </div>
            <h2>This share link is no longer active</h2>
            <p>Please contact your account manager to arrange a new share link</p>
        </div>
    );
};

export default MagicLinkNotActiveComponent;
